import { HomeGroupLayout } from './HomeGroupLayout';
export default HomeGroupLayout;
